<template>
  <v-dialog v-model="viewAppointment" width="500" persistent>
    <v-card class="pb-4">
      <v-card-title class="primary">
        <span class="white--text"
          >Appointment - {{ appointmentData.appointmentId }}</span
        >
      </v-card-title>
      <v-card-text class="subtitle-1 pb-0">
        <v-row>
          <v-col>
            <b>Appointment ID: </b> {{ appointmentData.appointmentId }}<br />
            <b>Start Date/Time: </b>
            {{ appointmentData.startDate | formatDateTime(true) }}<br />
            <b>End Date/Time: </b>
            {{ appointmentData.endDate | formatDateTime(true) }}<br />
            <b>PRI ID: </b> <br />
            <b>Port ID: </b> <br />
            <b>Primary Access Technology: </b>
          </v-col>
        </v-row>
      </v-card-text>

      <v-divider></v-divider>

      <v-card-text class="pb-0 pt-2">
        <v-row class="mb-2">
          <fancy-button
            :icon="`mdi-restart`"
            :text="`Reschedule`"
            @click="onTriggerReschedule"
          ></fancy-button>
          <fancy-button
            :icon="`mdi-cancel`"
            :text="`Cancel`"
            @click="onTriggerCancel"
          ></fancy-button>
        </v-row>
      </v-card-text>

      <v-divider></v-divider>

      <v-card-actions class="mt-4">
        <v-spacer></v-spacer>
        <v-btn @click="$emit('close-appointment')" class="mr-4">Close</v-btn>
      </v-card-actions>
    </v-card>
    <confirm-action
      :dialog="cancelDialog"
      :text="cancelDialogText"
      :proceedText="`Yes`"
      :cancelText="`No`"
      @onBtnClick="onCancelConfirm"
    ></confirm-action>
    <reschedule-appointment
      :appointmentData="appointmentData"
      :rescheduleAppointment="rescheduleDialog"
      @closeReschedule="rescheduleDialog = false"
      @processReschedule="onProcessReschedule"
    ></reschedule-appointment>
  </v-dialog>
</template>

<script>
export default {
  name: "ViewAppointment",
  data: () => ({
    cancelDialog: false,
    rescheduleDialog: false,
    cancelDialogText: "Are you sure you want to cancel this appointment?",
  }),
  props: {
    viewAppointment: {
      type: Boolean,
      required: true,
    },
    appointmentData: {
      type: Object,
      required: true,
    },
  },
  methods: {
    onProcessReschedule(args) {
      let vm = this;

      let payload = {
        action: "RESCHEDULE",
        appointment: {
          startDatetime: args.startDatetime,
          endDatetime: args.endDatetime,
          SlotType: args.timeSlot,
          appointmentId: vm.appointmentData.appointmentId,
        },
        appointmentId: vm.appointmentData.appointmentId,
      };

      vm.updateAppointment(payload).then(() => {
        vm.rescheduleDialog = false;
      });
    },
    onTriggerReschedule() {
      let vm = this;
      let payload = {
        appointment: {
          id: vm.appointmentData.appointmentId,
          slotType: vm.appointmentData.timeslot,
          startDatetime: vm.appointmentData.startDate,
          endDatetime: vm.appointmentData.endDate,
        },
      };
      vm.checkAvailableSlots(payload).then(() => {
        vm.rescheduleDialog = true;
      });
    },
    onTriggerCancel() {
      let vm = this;
      vm.cancelDialog = true;
    },
    onCancelConfirm(args) {
      let vm = this;

      if (args) {
        let payload = {
          action: "CANCEL",
          appointment: {
            startDatetime: args.startDatetime,
            endDatetime: args.endDatetime,
            SlotType: args.timeSlot,
            appointmentId: vm.appointmentData.appointmentId,
          },
          appointmentId: vm.appointmentData.appointmentId,
        };

        vm.updateAppointment(payload).then(() => {
          vm.cancelDialog = false;
        });
      } else vm.cancelDialog = false;

      // if (args) {
      // 	let payload = {
      // 		action: "CANCEL",
      // 		appointment: {
      // 			startDatetime: vm.appointmentData.startDatetime,
      // 			endDatetime: vm.appointmentData.endDatetime,
      // 			SlotType: vm.appointmentData.timeSlot
      // 		},
      // 		appointmentId: vm.appointmentData.appointmentID
      // 	};
      // 	vm.updateAppointment(payload);
      // }
      // vm.cancelDialog = false;
    },
  },
};
</script>